import { useQuery } from '@apollo/client'

import { queries } from '../../graphql'
import { Icons } from '..'

export function FundLogo({ logo: savedLogo, temporarySrc, sx, ...props }) {
  let logoImage

  if (
    temporarySrc &&
    (temporarySrc.startsWith('data:image/') || temporarySrc.startsWith('blob:')) &&
    !temporarySrc.includes('base64,null') &&
    !temporarySrc.includes('base64,undefined')
  ) {
    logoImage = (
      <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={temporarySrc} alt="temporary logo" />
    )
  } else if (savedLogo) {
    logoImage = (
      <img
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        src={`data:image/jpeg;base64,${savedLogo}`}
        alt="charity logo"
      />
    )
  } else {
    logoImage = <Icons.GrantThin style={{ height: '40%' }} />
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: savedLogo ? 'transparent' : '#f0f0f0',
      }}
    >
      {logoImage}
    </div>
  )
}
